import React, { useState, useContext, useEffect, useRef } from "react"
import LanguageContext from "../LanguageContext"
import "./Video.css"
import { Html } from "@react-three/drei"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import {isMobile} from 'react-device-detect';


const LOOK_AT_COORDS = [0, 0, 0]

function Video({
  position,
  rotation,
  scale,
  image,
  title,
  titleEng,
  handleModal,
  modalContentIT,
  modalContentEN,
  videoID,
  active,
  type,
  speaker,
}) {
  const [hidden, set] = useState()
  const [over, setOver] = useState()

  const [language, setLanguage] = useContext(LanguageContext)

  const mesh = useRef()
  useEffect(() => {
    mesh.current.lookAt(...LOOK_AT_COORDS)
    //mesh.current.translateZ(20)
  }, [mesh])

  const imageGV = getImage(image)

  const modalContentObj = [
    {
      language: "IT",
      title:title,
      videoID,
      body: modalContentIT,
      speaker
    },
    {
      language: "EN",
      title: titleEng,
      videoID,
      body: modalContentEN,
      speaker
    },
  ]



  return (
    <mesh  scale={scale} position={position} rotation={rotation} ref={mesh}  >

      <Html
        
        //occlude
        //onOcclude={set}
        style={{
          transition: " 3s all",
          opacity: hidden ? 0 : 1,
          visibility: hidden ? "hidden" : "visible",
          //transform: `scale(${over ? 1.2 : 1})`,
        }}
        center
        
        distanceFactor={`${isMobile ? 30 : 20}`}
        zIndexRange={[100, 0]}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 228.67 317.59"
          className={`${type} ${over ? "__over" : ""} topright-corner`}
        >
          <g id="Livello_2" data-name="Livello 2">
            <g id="Livello_1-2" data-name="Livello 1">
              <polygon
                class="cls-1"
                points="228.67 0 0 11.71 7.19 145.29 57.54 142.41 73.04 312.24 206.49 317.59 228.67 0"
              />
            </g>
          </g>
        </svg>
        <svg
          className={`${type} ${over ? "__over" : ""} bottomleft-corner`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 253.2 309.18"
        >
          <g id="Livello_2" data-name="Livello 2">
            <g id="Livello_1-2" data-name="Livello 1">
              <polygon
                class="cls-1"
                points="0 7.1 0.13 304.59 253.2 309.18 253.2 169.2 137.45 175.41 134.79 0 0 7.1"
              />
            </g>
          </g>
        </svg>
        
        <div
          onMouseEnter={() => {
            if (active) {
              setOver(true)
            }
          }}
          onMouseLeave={() => {
            if (active) {
              setOver(false)
            }
          }}
          className="Video__content"
          //style={{ backgroundImage: `url("${image}")` }}
        >
          <div
            className="Video__title"
            style={{
              transition: `.5s all`,
              position: `relative`,
              top: 0,
              left: 0,
              width: `100%`,
              height: `100%`,
              zIndex: `100`
            }}
            onClick={() => {
              if (active) {

                handleModal(modalContentObj)
              }
            }}
          >
            
            <span
              style={{
                fontSize: `.7rem`,
                color: `white`,
                zIndex: `3`,
                position: `absolute`,
                top: `10px`,
                maxWidth: `60%`,
                background: type == "green-voice" ? "#2b5d64" : "#4ce9b5",
                lineHeight: `1.2`,
                padding: ".3rem",
              }}
            >
              <span>{language == "IT" ? title : titleEng}</span>
            </span>
          </div>
          
          <GatsbyImage image={imageGV} />
          {!active && (
            <div className={`Video__title_comingsoon ${type}`}>
               <span
              style={{
                fontSize: `.7rem`,
                color: `white`,
                zIndex: `3`,
                position: `absolute`,
                top: `10px`,
                maxWidth: `60%`,
                background: type == "green-voice" ? "#2b5d64" : "#4ce9b5",
                lineHeight: `1.2`,
                padding: ".3rem",
              }}
            >
              <span>{title}</span>
            </span>
            </div>
          )}
        </div>
      </Html>
    </mesh>
  )
}

export default Video
